module.exports = __webpack_public_path__ + "img/556150.9bcce9f6.png";